import { render, staticRenderFns } from "./ProfileQuestions.vue?vue&type=template&id=192ab194&scoped=true"
import script from "./ProfileQuestions.vue?vue&type=script&lang=js"
export * from "./ProfileQuestions.vue?vue&type=script&lang=js"
import style0 from "./ProfileQuestions.vue?vue&type=style&index=0&id=192ab194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ab194",
  null
  
)

export default component.exports